/* eslint-disable no-multi-assign */
import { Window } from '../../00_IMMEDIATE/Window';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';

class Window_BotOptIn extends Window {
  /**
   * constructor
   */
  constructor(parent) {
    super(parent);
    this._initLayout();
    this._initButtons();
    OMT.platformTracking.logEvent(OMT.platformTracking.Events.BotOptInPopUpVisible);
  }

  /**
   * init layout content / graphics
   */
  _initLayout() {
    // background
    this.addBackground('popup_background_2');

    // title
    this.titleTxt = new G.Text(0, -272, OMT.language.getText('Subscribe'), G.OMTsettings.elements.Window_botOptIn.titleTxt.style, 0.5, 420);
    this.add(this.titleTxt);

    // subscribe img bg
    const originalBGDimensions = this.bg.getBounds().clone();
    this.bg = G.makeImage(0, -80, 'Subscribe_BG', 0.5, this);
    this.bg.scale.x = this.bg.scale.y = 0.9;

    // subscribe image
    this.img = G.makeImage(0, -60, 'Subscribe_image', 0.5, this);
    this.img.scale.x = this.img.scale.y = 0.8;

    // text fields
    this.errorTxt = new G.Text(0, -50, OMT.language.getText('Something went wrong, try again later'), {
      style: 'font-purple',
      fontSize: '48px',
    }, 0.5, 420, 300, true, 'center');
    this.add(this.errorTxt);
    this.errorTxt.visible = false;

    this.txt = new G.Text(0, 60, OMT.language.getText('Do you want daily gifts from notifications?'), {
      style: 'font-darkBlueRubik',
      fontSize: '30px',
      lineSpacing: -10,
    }, 0.5, originalBGDimensions.width * 0.8, originalBGDimensions.height * 0.8, true, 'center');
    this.add(this.txt);

    if (!G.saveState.wasBotOptInGiftGiven()) {
      this.txt = new G.Text(0, 130, OMT.language.getText('Get [Amount] coins now, plus gifts every day!?').replace('[Amount]', G.json.settings.botOptCoinReward), {
        style: 'font-darkBlueRubik',
        fontSize: '22px',
        lineSpacing: -10,
      }, 0.5, originalBGDimensions.width * 0.8, originalBGDimensions.height * 0.8, true, 'center');
      this.add(this.txt);
    }
  }

  /**
   * init buttons
   */
  _initButtons() {
    // continue button
    this.continueBtnTxt = new G.Text(0, 380, OMT.language.getText('No, thanks'), {
      style: 'font-white',
      fontSize: '32px',
      lineSpacing: -15,
    }, 0.5, 420, 420, true, 'center');
    this.add(this.continueBtnTxt);
    this.continueBtnTxt.inputEnabled = true;
    this.continueBtnTxt.input.useHandCursor = true;
    this.continueBtnTxt.events.onInputDown.add(() => {
      G.saveState.data.showOptinIcon = false;
      G.saveState.save();
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.BotOptInPopUpNoThanks);
      this.closeWindow();
    }, this);
    this.registerButtons(this.continueBtnTxt);
    this.underline = this.game.add.graphics(this.continueBtnTxt.left, this.continueBtnTxt.bottom - 7);
    this.underline.lineStyle(4, 0xFFFFFF);
    this.underline.moveTo(0, 0);
    this.underline.lineTo(this.continueBtnTxt.width, 0);
    this.add(this.underline);

    // opt-in button
    this.optInBtn = new OMT_UI_SquareButton(0, 220, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 445,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Yes'),
        textStyle: { style: 'font-white', fontSize: 40, lineSpacing: -15 },
      },
      options: {
        clickFunction: {
          onClick: this._onOptIn.bind(this),
        },
        pulse: 1.1,
      },
    });
    this.registerButtons(this.optInBtn);
  }

  /**
   * on user opt-in clicked
   */
  _onOptIn() {
    let reward = false;
    OMT.bots.subscribeToBot().then(() => {
      G.Helpers.mapChestsMgr.iconAndPopupIn(-1, -1);
      G.Helpers.bubbleGiftsMgr.iconAndPopupIn(-1, -1);
      if (!G.saveState.wasBotOptInGiftGiven()) reward = true;
      G.saveState.setBotOptIn(true);
      OMT.notifications.unscheduleAllGameTriggeredMessages('a2u');
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.BotOptInPopUpYes);
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.BotOptIn);
      DDNA.tracking.collectEvent('botOptionsChanged', { botSubscribtionStatus: 1, botSubscriptionChangeGameArea: 'BotOptIn' });
      G.saveState.data.showOptinIcon = false;
      G.saveState.save();
      this.closeWindow(() => {
        if (reward) this._rewardForOptIn();
      });
    }).catch((err) => {
      G.Helpers.mapChestsMgr.iconAndPopupIn(-1, -1);
      G.Helpers.bubbleGiftsMgr.iconAndPopupIn(-1, -1);
      this.closeWindow(() => {
        if (err.code === 'USER_INPUT') {
          G.saveState.data.showOptinIcon = false;
          G.saveState.save();
        }
      });
    });
  }

  /**
   * give opt-in reward
   */
  _rewardForOptIn() {
    const gift = [
      ['coin', G.json.settings.botOptCoinReward],
    ];
    G.WorldMapAppearFlow.flowMgr.onPopUpReqested.dispatch(['gift', {
      titleTextBar: {
        titleTxt: OMT.language.getText('Thanks for subscribing!'),
      },
      showGingy: false,
      showGingyGiftBar: false,
      autoOpen: true,
      autoOpenDelay: 1500,
      gifts: gift,
      onClaim: () => {
        DDNA.transactionHelper.trackRewards(gift, [], {
          transactionType: 'REWARD', tActionType: 'BOT_SUBSCRIBE', tGameArea: 'MAP',
        });
        OMT.platformTracking.logEvent(OMT.platformTracking.Events.BotOptInCollectReward);
        G.saveState.markBotOptInGiftGiven();
      },
      monetiseType: false,
      resourceTracking: {
        itemType: 'Reward',
        itemId: 'Subscription Reward',
      },
      shareable: false,
    }], false, G.WindowMgr.LayerNames.Base);
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.botOptIn = Window_BotOptIn;
